import {HardwareGroupWithContent} from "../../../../api/Hardware";
import {groupByArr} from "nate-react-api-helpers";
import {Alert, AlertTitle} from "@mui/material";
import {Link} from "react-router-dom";
import {makeHeadingId} from "./HwEditingContextProvider";

export function DiscontinuedWarning(props: {
    data: HardwareGroupWithContent[]
}) {
    let discontinuedItems = props.data.map(d => ({
        id: d.id,
        name: d.name,
        discontinued: d.hardware.filter(h => h.discontinued),
    }))
        .filter(v => v.discontinued.length > 0)
        .flatMap(v => v);

    if(discontinuedItems.length === 0) return null;

    const invert = discontinuedItems.flatMap(v => {
        return v.discontinued.map(d => ({
            id: v.id,
            name: v.name,
            hwItem: d,
        }))
    });

    const list = groupByArr(invert, d => d.hwItem.product);

    return (<Alert severity="warning">
            <AlertTitle>Some Products have been Discontinued</AlertTitle>
            <ul>
            {list.map(d => {
                const val = d.values[0].hwItem

                return (
                    <li>
                        {val.category} {val.productCode} ({val.finish}) by {val.manufacturerName}
                        <ul>
                            {d.values.map(v => <li key={v.hwItem.id}>
                                <Link to={`#${makeHeadingId(v.id)}`} onClick={() => {
                                    const el = document.getElementById(makeHeadingId(v.id))
                                    if(!el) return;

                                    el.scrollIntoView({
                                        block: "start",
                                    });
                                }}>{v.name}</Link>
                            </li>)}
                        </ul>
                    </li>
                )
            })}
            </ul>
        </Alert>
    )
}